import Breadcrumb from '@/components/ui/Breadcrumb'
import AboutSection from '@/components/pages/AboutUs/WhoWeAre/AboutSection'
import MemberCountries from '@/components/sections/MemberCountries'
import InfoCardGrid from '@/components/sections/InfoCardGrid'
// import StrategicPillars from '@/components/sections/StrategicPillars'
import RecentArticles from '@/components/sections/RecentArticles'
import Newsletter from '@/components/sections/Newsletter'
import { useAllWebPages } from '@/lib/api/hooks/web-pages'
import FullPageSpinner from '@/components/ui/FullPageSpinner'
import { motion } from 'framer-motion'
import { fadeUp, staggerContainer, viewportReveal } from '@/lib/motion'

const WhoWeAre = () => {
  const { data, isFetching, isError, refetch } = useAllWebPages();

  const whoWeAreData = data?.data && data?.data.find((page) =>
    page.codeName?.toLowerCase() === 'who_we_are' ||
    page.websitePageName?.toLowerCase() === 'who we are'
  )?.content || null;

  if (isFetching) {
    return <FullPageSpinner />;
  }

  if (isError) {
    return <div className="p-4 flex flex-col items-center justify-center h-full w-full gap-4">
      <p>Error loading page.</p>
      <button onClick={() => refetch()} className="px-4 py-2 bg-forestGreen-100 text-white rounded">Retry</button>
    </div>;
  }

  if (!whoWeAreData) {
    return <div className="p-4 flex flex-col items-center justify-center h-full w-full gap-4">
      <p>Page content not found.</p>

    </div>;
  }


  return (
    <motion.div
      className="bg-white min-h-screen"
      variants={staggerContainer}
      initial="hidden"
      animate="visible"
    >
      {/* Breadcrumb */}
      <motion.div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 " variants={fadeUp}>
        <Breadcrumb
          items={[
            { label: 'Home', href: '/' },
            { label: 'About Us', href: '/about' },
            { label: 'Who we are', href: '/about/who-we-are', active: true }
          ]}
        />
      </motion.div>


      <motion.div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8" variants={fadeUp}>
        <img
          src={whoWeAreData?.WHO_ARE_WE_BANNER?.fileUrl ?? "https://res.cloudinary.com/dlwegkhme/image/upload/v1756135981/b467cbb129e3f72467993c785f41b2ffab8d0f62_1_cqe6qb.png"}
          alt="African Space Agency Building"
          className="w-full  lg:h-[480px] aspect-video object-cover "
        />
      </motion.div>


      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <AboutSection data={whoWeAreData} />
      </motion.div>

      {
        whoWeAreData?.WHO_ARE_WE_MEMBER_COUNTRIES && (
          <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
            <MemberCountries data={whoWeAreData?.WHO_ARE_WE_MEMBER_COUNTRIES} />
          </motion.div>
        )
      }




      <motion.div
        className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-16"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={viewportReveal}
      >
        <motion.div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16" variants={staggerContainer}>

          <motion.div className="lg:col-span-2 space-y-24" variants={fadeUp}>
            <InfoCardGrid data={whoWeAreData} />
            <Newsletter />
          </motion.div>


          <motion.div className="space-y-10" variants={fadeUp}>
            <RecentArticles />
            {/* <StrategicPillars /> */}
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  )
}

export default WhoWeAre